import { useStrings } from "@1js/localization-components";
import { Tab } from "@fluentui/react-components";
import React from "react";
import { BookmarkedPromptsLabel } from "./PromptTab.strings";

export const BookmarkTab = () => {
  const localizations = useStrings({
    BookmarkedPromptsLabel,
  });
  return (
    <Tab
      aria-label={localizations.BookmarkedPromptsLabel()}
      value={"SavedPrompts"}
      data-testid="bookmarked-prompts-tab"
    >
      {localizations.BookmarkedPromptsLabel()}
    </Tab>
  );
};
